import React, { useEffect, useState, useContext } from 'react';
import { Col, Row, Button, Modal, Form, Alert } from 'react-bootstrap';
import { BsPlus, BsPencil } from 'react-icons/bs';
import { MdSearch, MdFilterList } from 'react-icons/md';
import Breadcrumbs from '../../components/layout/breadcrumbs';
import Page from '../../components/page';
import { api } from '../../providers/apiClient';
import { ContextUser } from '../../providers/ContextUser';
import { ContextSearch } from '../../providers/ContextSearch';
import Search from '../../components/search';
import NoResults from '../../components/no-result';
import { toast } from 'react-toastify';
import {
  UsersContainer,
  UsersHeader,
  SearchSection,
  FilterButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Select,
  ButtonGroup,
  ActionButton,
  DeleteButton,
  EditButton,
  AddButton,
  CustomButton,
  ListActionButton,
  // novos estilos de grade
  Container,
  TableBox,
  CustomTable,
  CustomTableHead,
  CustomTableBody,
  CustomTableRow,
  CustomTH,
  CustomTD,
  ActionsTH,
  FilterSection as GridFilterSection,
  FilterContainer,
  FilterInputContainer,
  FilterSelectContainer,
  CustomInputGroup,
  SearchIconBox,
  CustomFormControl,
  CustomSelectRounded,
  StatusBadge,
} from './styles';

const PageOrganizations = ({ isCollapsed }) => {
  const { currentUser, currentOrganization } = useContext(ContextUser);
  const { searchValues, setSearchValues, clearPageFilters } = useContext(ContextSearch);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const [searchOrgResult, setSearchOrgResult] = useState([]);
  // filtros no cabeçalho
  const [headerFilters, setHeaderFilters] = useState({
    text: '',
    status: '',
  });
  const [users, setUsers] = useState([]);
  const [types, setTypes] = useState([]);
  const [states] = useState([
    { code: '', name: 'Selecione um estado...' },
    { code: 'AC', name: 'Acre' },
    { code: 'AL', name: 'Alagoas' },
    { code: 'AP', name: 'Amapá' },
    { code: 'AM', name: 'Amazonas' },
    { code: 'BA', name: 'Bahia' },
    { code: 'CE', name: 'Ceará' },
    { code: 'DF', name: 'Distrito Federal' },
    { code: 'ES', name: 'Espírito Santo' },
    { code: 'GO', name: 'Goiás' },
    { code: 'MA', name: 'Maranhão' },
    { code: 'MT', name: 'Mato Grosso' },
    { code: 'MS', name: 'Mato Grosso do Sul' },
    { code: 'MG', name: 'Minas Gerais' },
    { code: 'PA', name: 'Pará' },
    { code: 'PB', name: 'Paraíba' },
    { code: 'PR', name: 'Paraná' },
    { code: 'PE', name: 'Pernambuco' },
    { code: 'PI', name: 'Piauí' },
    { code: 'RJ', name: 'Rio de Janeiro' },
    { code: 'RN', name: 'Rio Grande do Norte' },
    { code: 'RS', name: 'Rio Grande do Sul' },
    { code: 'RO', name: 'Rondônia' },
    { code: 'RR', name: 'Roraima' },
    { code: 'SC', name: 'Santa Catarina' },
    { code: 'SP', name: 'São Paulo' },
    { code: 'SE', name: 'Sergipe' },
    { code: 'TO', name: 'Tocantins' },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [editingOrg, setEditingOrg] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    responsible: '',
    status: true,
    typeId: '',
    stateCode: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Função para limpar erros específicos
  const clearFieldError = (fieldName) => {
    if (formErrors[fieldName]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  // Função para lidar com seleção de imagem
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Função para remover imagem selecionada
  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  // Carrega dados na montagem do componente
  useEffect(() => {
    const loadData = async () => {
      try {
        setIsFetching(true);
        
        const promises = [
          api.get('/orgs'),
          api.get('/users/hierarchy'), // Usa rota de hierarquia que já funciona
          api.get('/auth/types')
        ];
        
        const responses = await Promise.all(promises);
        const orgs = responses[0].data || [];
        const allUsers = responses[1].data?.users || [];
        const typesData = responses[2].data || [];
        
        // Filtra apenas usuários ADMIN (1) e ACCESS_ORG_LEVEL (2)
        const usersData = allUsers.filter(user => 
          user.role?.id === 1 || user.role?.id === 2
        );
        
        
        setOrganizations(orgs);
        setUsers(usersData);
        setTypes(typesData);
        
        // Constrói breadcrumbs
        setBreadcrumbs([
          { id: '/', label: 'admin', key: 'admin' },
          { id: '/organizacoes', label: 'Organizações', key: 'admin' }
        ]);
        
        // Aplica filtros salvos após carregar dados
        applyFiltersLocally(orgs, searchValues['organizations'] || {});
        
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        toast.error('Erro ao carregar organizações');
      } finally {
        setIsFetching(false);
      }
    };

    loadData();
  }, [currentUser, currentOrganization]);

  // Aplica filtros localmente quando searchValues ou headerFilters mudar
  useEffect(() => {
    if (organizations.length > 0) {
      const base = { ...(searchValues['organizations'] || {}) };
      const merged = { ...base, ...headerFilters };
      applyFiltersLocally(organizations, merged);
    }
  }, [searchValues, organizations, headerFilters]);

  // Função para aplicar filtros localmente
  const applyFiltersLocally = (allOrgs, filters) => {
    let filteredOrgs = [...allOrgs];
    
    // Filtro por texto
    if (filters.text && filters.text.trim()) {
      const searchFields = ['name'];
      const searchText = filters.text.toLowerCase();
      filteredOrgs = filteredOrgs.filter(org => 
        searchFields.some(field => 
          org[field]?.toLowerCase().includes(searchText)
        )
      );
    }
    
    // Filtro por status
    if (filters.status && filters.status !== '') {
      filteredOrgs = filteredOrgs.filter(org => {
        const orgStatus = org.status;
        return String(orgStatus) === filters.status;
      });
    }
    
    setSearchOrgResult(filteredOrgs);
  };

  const handleClearFilters = () => {
    clearPageFilters('organizations');
    const currentFilters = JSON.parse(localStorage.getItem('filters') || '{}');
    currentFilters.organizations = { text: '', status: '' };
    localStorage.setItem('filters', JSON.stringify(currentFilters));
    setHeaderFilters({ text: '', status: '' });
  };

  const hasActiveFilters = (headerFilters.text && headerFilters.text.trim()) || (headerFilters.status && headerFilters.status !== '');

  const handleOpenModal = (org = null) => {
    setEditingOrg(org);
    
    if (org) {
        
        setFormData({
          name: org.name || '',
          responsible: org.responsible || org.responsibleUser?.id || '',
          status: org.status ?? true,
          typeId: org.typeId || '',
          stateCode: org.stateCode || '',
        });
        setImagePreview(org.imageUrl || null);
    } else {
      setFormData({
        name: '',
        responsible: '',
        status: true,
        typeId: '',
        stateCode: '',
      });
      setImagePreview(null);
    }
    setSelectedImage(null);
    setFormErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingOrg(null);
    setFormData({
      name: '',
      responsible: '',
      status: true,
      typeId: '',
      stateCode: '',
    });
    setSelectedImage(null);
    setImagePreview(null);
    setFormErrors({});
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'Nome é obrigatório';
    }
    
    if (!formData.responsible) {
      errors.responsible = 'Responsável é obrigatório';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name.trim());
      formDataToSend.append('responsible', formData.responsible);
      formDataToSend.append('status', formData.status);
      formDataToSend.append('typeId', formData.typeId || '');
      formDataToSend.append('stateCode', formData.stateCode || '');
      
      if (selectedImage) {
        formDataToSend.append('image', selectedImage);
      }

      if (editingOrg) {
        await api.patch(`/orgs/${editingOrg.id}`, formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        toast.success('Organização atualizada com sucesso!');
      } else {
        await api.post('/orgs', formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        toast.success('Organização criada com sucesso!');
      }

      // Recarrega a lista de organizações
      const response = await api.get('/orgs');
      const allOrgs = response.data || [];
      setOrganizations(allOrgs);
      applyFiltersLocally(allOrgs, searchValues['organizations'] || {});
      
      handleCloseModal();
    } catch (error) {
      console.error('Erro ao salvar organização:', error);
      
      // Tratamento de erros específicos
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro ao salvar organização';
      const errorData = error.response?.data;
      
      console.log('Erro completo:', { errorMessage, errorData, error });
      
      // Verifica se é erro de nome já cadastrado
      if (errorMessage.includes('nome já cadastrado') || 
          errorMessage.includes('name already exists') ||
          errorMessage.includes('Unique constraint failed on the constraint: `Org_name_key`') ||
          (errorData && errorData.code === 'P2002' && errorData.meta?.target?.includes('name'))) {
        toast.error('Este nome já está cadastrado no sistema');
        setFormErrors(prev => ({ ...prev, name: 'Este nome já está cadastrado' }));
      }
      // Outros erros
      else {
        toast.error(errorMessage);
      }
    }
  };


  const getUserName = (responsible) => {
    // Se responsible é um objeto (vem da API), usa diretamente
    if (responsible && typeof responsible === 'object' && responsible.name) {
      return responsible.name;
    }
    
    // Se responsible é um ID (string), busca na lista de usuários
    if (responsible && typeof responsible === 'string') {
      const user = users.find(u => u.id === responsible);
      return user ? user.name : 'Usuário não encontrado';
    }
    
    return 'Usuário não encontrado';
  };

  const getTypeName = (typeId) => {
    const type = types.find(t => t.id === typeId);
    return type ? type.description : 'N/A';
  };

  const canEditOrg = (org) => {
    // Apenas ADMIN pode editar organizações
    return currentUser?.role === 'ADMIN';
  };


  return (
    <>
      <Breadcrumbs id='breadcrumbs-organizations' path={breadcrumbs} />
      <Page id='page-organizations' title='Organizações'>
        <UsersHeader id='organizations-header'>
          <GridFilterSection id='organizations-filter-section'>
            <FilterContainer id='organizations-filter-container'>
              <FilterInputContainer id='organizations-filter-input-container'>
                <CustomInputGroup id='organizations-search-input'>
                  <SearchIconBox>
                    <MdSearch />
                  </SearchIconBox>
                  <CustomFormControl
                    id='organizations-filter-text'
                    type="text"
                    placeholder="Buscar por nome..."
                    value={headerFilters.text}
                    onChange={(e) => setHeaderFilters(prev => ({ ...prev, text: e.target.value }))}
                  />
                </CustomInputGroup>
              </FilterInputContainer>

              <FilterSelectContainer id='organizations-filter-status-container'>
                <CustomSelectRounded
                  id='organizations-filter-status'
                  value={headerFilters.status}
                  onChange={(e) => setHeaderFilters(prev => ({ ...prev, status: e.target.value }))}
                >
                  <option value="">Busque por status...</option>
                  <option value="true">Ativo</option>
                  <option value="false">Inativo</option>
                </CustomSelectRounded>
              </FilterSelectContainer>
            </FilterContainer>
          </GridFilterSection>

          <ButtonGroup>
            {hasActiveFilters && (
              <CustomButton id='organizations-clear-filters-btn' onClick={handleClearFilters}>
                <MdFilterList />
                Limpar filtros
              </CustomButton>
            )}
            <CustomButton id='add-organization-btn' onClick={() => handleOpenModal()}>
              <BsPlus />
              Nova organização
            </CustomButton>
          </ButtonGroup>
        </UsersHeader>

        <Container id='organizations-table-container'>
          <TableBox className='table-responsive'>
            <CustomTable id='organizations-table'>
              <CustomTableHead id='organizations-table-head'>
                <CustomTableRow id='organizations-table-head-row'>
                  <CustomTH id='th-nome'>Nome</CustomTH>
                  <CustomTH id='th-responsavel'>Responsável</CustomTH>
                  <CustomTH id='th-tipo'>Tipo</CustomTH>
                  <CustomTH id='th-estado'>Estado</CustomTH>
                  <CustomTH id='th-status'>Status</CustomTH>
                  <ActionsTH id='th-acoes'></ActionsTH>
                </CustomTableRow>
              </CustomTableHead>
              <CustomTableBody id='organizations-table-body'>
                {isFetching ? (
                  [0,1,2,3,4].map(item => (
                    <CustomTableRow key={`skeleton-row-${item}`} id={`skeleton-row-${item}`}>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '120px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '160px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '90px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '80px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD><div className="skeleton-card" style={{ height: '14px', width: '80px', background: '#f0f0f0', borderRadius: '4px' }} /></CustomTD>
                      <CustomTD></CustomTD>
                    </CustomTableRow>
                  ))
                ) : (
                  (searchOrgResult.length > 0 ? searchOrgResult : []).map((org) => (
                    <CustomTableRow id={`organizations-row-${org.id}`} key={org.id}>
                      <CustomTD id={`org-name-${org.id}`}>{org.name}</CustomTD>
                      <CustomTD id={`org-responsible-${org.id}`}>{getUserName(org.responsibleUser || org.responsible)}</CustomTD>
                      <CustomTD id={`org-type-${org.id}`}>{getTypeName(org.typeId)}</CustomTD>
                      <CustomTD id={`org-state-${org.id}`}>{org.stateCode || 'N/A'}</CustomTD>
                      <CustomTD id={`org-status-${org.id}`}>
                        <StatusBadge className={`status-${org.status ? 'active' : 'inactive'}`}>
                          {org.status ? 'Ativo' : 'Inativo'}
                        </StatusBadge>
                      </CustomTD>
                      <CustomTD className='text-center'>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                          {canEditOrg(org) && (
                            <ListActionButton id={`edit-org-${org.id}`} className='action-button secondary' onClick={() => handleOpenModal(org)}>
                              <BsPencil />
                              Editar
                            </ListActionButton>
                          )}
                        </div>
                      </CustomTD>
                    </CustomTableRow>
                  ))
                )}
              </CustomTableBody>
            </CustomTable>
          </TableBox>
          {!isFetching && searchOrgResult.length === 0 && (
            <UsersContainer id='org-no-results'>
              <NoResults id='no-results-organizations' message='Nenhuma organização encontrada' searchText={headerFilters.text} />
            </UsersContainer>
          )}
        </Container>

        {/* Modal de Cadastro/Edição */}
        <Modal id='organization-modal' show={showModal} onHide={handleCloseModal} size='lg'>
          <ModalHeader id='organization-modal-header' closeButton>
            <Modal.Title>
              {editingOrg ? 'Editar Organização' : 'Nova Organização'}
            </Modal.Title>
          </ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody id='organization-modal-body'>
              {/* Nome */}
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <Label htmlFor='org-name'>Nome *</Label>
                    <Input
                      id='org-name'
                      type='text'
                      value={formData.name}
                      onChange={(e) => {
                        setFormData({ ...formData, name: e.target.value });
                        clearFieldError('name');
                      }}
                      isInvalid={!!formErrors.name}
                      style={{ height: '40px' }}
                    />
                    {formErrors.name && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.name}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              
              {/* Responsável | Status */}
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='org-responsible'>Responsável *</Label>
                    <Select
                      id='org-responsible'
                      value={formData.responsible}
                      onChange={(e) => {
                        setFormData({ ...formData, responsible: e.target.value });
                        clearFieldError('responsible');
                      }}
                      isInvalid={!!formErrors.responsible}
                      style={{ height: '40px', padding: '10px' }}
                    >
                      <option value=''>Selecione um responsável...</option>
                      {users.map(user => (
                        <option key={user.id} value={user.id}>
                          {user.name}
                        </option>
                      ))}
                    </Select>
                    {formErrors.responsible && (
                      <div className='text-danger small mt-1' style={{ fontSize: '0.875rem' }}>
                        {formErrors.responsible}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='org-status'>Status</Label>
                    <Select
                      id='org-status'
                      value={formData.status ? 'true' : 'false'}
                      onChange={(e) => setFormData({ ...formData, status: e.target.value === 'true' })}
                      style={{ height: '40px', padding: '10px' }}
                    >
                      <option value={'true'}>Ativo</option>
                      <option value={'false'}>Inativo</option>
                    </Select>
                  </FormGroup>
                </Col>
              </Row>

              {/* Tipo | Estado */}
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='org-type'>Tipo</Label>
                    <Select
                      id='org-type'
                      value={formData.typeId}
                      onChange={(e) => setFormData({ ...formData, typeId: e.target.value })}
                      style={{ height: '40px', padding: '10px' }}
                    >
                      <option value=''>Selecione um tipo...</option>
                      {types.map(type => (
                        <option key={type.id} value={type.id}>
                          {type.description}
                        </option>
                      ))}
                    </Select>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label htmlFor='org-state'>Estado</Label>
                    <Select
                      id='org-state'
                      value={formData.stateCode}
                      onChange={(e) => setFormData({ ...formData, stateCode: e.target.value })}
                      style={{ height: '40px', padding: '10px' }}
                    >
                      {states.map(state => (
                        <option key={state.code} value={state.code}>
                          {state.name}
                        </option>
                      ))}
                    </Select>
                  </FormGroup>
                </Col>
              </Row>

              {/* Upload de Imagem */}
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <Label htmlFor='org-image'>Imagem da Organização</Label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <div style={{ flex: 1 }}>
                        <Input
                          id='org-image'
                          type='file'
                          accept='image/*'
                          onChange={handleImageChange}
                          style={{ height: '40px' }}
                        />
                      </div>
                      {imagePreview && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <img
                            src={imagePreview}
                            alt='Preview'
                            style={{
                              width: '60px',
                              height: '60px',
                              objectFit: 'cover',
                              borderRadius: '8px',
                              border: '1px solid #ddd'
                            }}
                          />
                          <Button
                            type='button'
                            variant='outline-danger'
                            size='sm'
                            onClick={handleRemoveImage}
                            style={{ height: '32px' }}
                          >
                            Remover
                          </Button>
                        </div>
                      )}
                    </div>
                    <small className='text-muted'>
                      Formatos aceitos: JPG, PNG, GIF. Tamanho máximo: 5MB
                    </small>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter id='organization-modal-footer'>
              <Button variant='light' onClick={handleCloseModal}>
                Cancelar
              </Button>
              <Button variant='primary' type='submit'>
                {editingOrg ? 'Atualizar' : 'Criar'}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    </>
  );
};

export default PageOrganizations;
